import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=448b7140&scoped=true&"
import script from "./Particles.vue?vue&type=script&lang=js&"
export * from "./Particles.vue?vue&type=script&lang=js&"
import style0 from "./Particles.vue?vue&type=style&index=0&id=448b7140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b7140",
  null
  
)

export default component.exports